import { supabase } from '../lib/supabase';

export interface CreateSurveyParams {
  entityType: 'production' | 'sample';
  entityId: string;
  entityName: string;
  salesperson: string;
  clientId?: string;
  clientName?: string;
  clientEmail?: string;
}

function generateToken(): string {
  return crypto.randomUUID().replace(/-/g, '').slice(0, 24);
}

export async function hasCompletedSurveyForEntity(entityType: 'production' | 'sample', entityId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('satisfaction_surveys')
    .select('id')
    .eq('entity_type', entityType)
    .eq('entity_id', entityId)
    .eq('status', 'completed')
    .limit(1)
    .maybeSingle();
  if (error) return false;
  return !!data;
}

export async function deletePendingSurveysForEntity(entityType: 'production' | 'sample', entityId: string): Promise<void> {
  await supabase
    .from('satisfaction_surveys')
    .delete()
    .eq('entity_type', entityType)
    .eq('entity_id', entityId)
    .eq('status', 'pending');
}

export async function createSatisfactionSurvey(params: CreateSurveyParams): Promise<{ token: string; surveyId: string } | null> {
  const hasCompleted = await hasCompletedSurveyForEntity(params.entityType, params.entityId);
  if (hasCompleted) return null;

  const token = generateToken();
  const { data, error } = await supabase
    .from('satisfaction_surveys')
    .insert({
      token,
      entity_type: params.entityType,
      entity_id: params.entityId,
      entity_name: params.entityName,
      salesperson: params.salesperson,
      client_id: params.clientId || null,
      client_name: params.clientName || null,
      client_email: params.clientEmail || null,
      status: 'pending',
    })
    .select('id')
    .single();

  if (error) {
    console.error('Error creating satisfaction survey:', error);
    return null;
  }
  return { token, surveyId: data.id };
}

export function getSurveyUrl(token: string): string {
  const base = typeof window !== 'undefined' ? window.location.origin : 'https://www.productex.app';
  return `${base}/satisfaction/${token}`;
}

export function getSurveyMessage(token: string): string {
  const link = `https://www.productex.app/satisfaction/${token}`;
  return `Para nosotros es muy importante tu opinión, por eso te estoy pasando un link para que completes esta breve encuesta de satisfacción, me ayudarias completandola? (No lleva más de 1 minuto)

${link}

¡Gracias por confiar en Productex!`;
}
